import { useForm } from "react-hook-form";

export type UserFormValues = {
  firstName:    string;
  lastName:     string;
  email:        string;
  user_type:    "agency" | "monitoring" | "admin";
  org_role:     string;
  organization: string;
  department:   string;
  permissions:  string[];
};

const DEFAULTS: UserFormValues = {
  firstName:    "",
  lastName:     "",
  email:        "",
  user_type:    "agency",
  org_role:     "member",
  organization: "",
  department:   "",
  permissions:  [],
};

export function useUserForm() {
  return useForm<UserFormValues>({ defaultValues: DEFAULTS });
}
